export default [
  {
    path: "/origenOferta",
    component: () => import("@/views/origenOferta/Listar.vue"),
  },
  {
    path: "/origenOferta/crear",
    component: () => import("@/views/origenOferta/Crear.vue"),
  },
  {
    path: "/origenOferta/editar/:id",
    component: () => import("@/views/origenOferta/Editar.vue"),
  },
];
